export const USERNAME_REGEX =
  /^(?:[A-Z\d_@.]{6,50}|[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4})$/i;
export const URL_NO_TRAILING_SLASH_REGEX = /^(http|https):\/\/([^/ ]+)[^/.]$/;
export const URL_REGEX =
  /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w.-]+)+[\w\-._~:/?#[\]@!$&'()*+,;=.]+$/;
export const URL_REGEX_WITHOUT_LOCALHOST =
  /^(https?:\/\/)?([a-z0-9-]+\.)*[a-z0-9-]+\.[a-z]{2,}(\/.*)?$/;
export const WITHOUT_ZERO = /^[1-9][0-9]*$/;
export const NIC_REGEX = /^([0-9]{9}[x|X|v|V]|[0-9]{12})$/;
